import { Diamond } from 'shared/icons/Diamond';
import { Hourglass } from 'shared/icons/Hourglass';
import { Oval } from 'shared/icons/Oval';
import { Rectangle } from 'shared/icons/Rectangle';
import { Slash } from 'shared/icons/Slash';
import { Triangle } from 'shared/icons/Triangle';
import { t } from 'localization/utils/t';

const TP = 'productTemplate.enums.fitFeedback';

export const HEIGHT_MEASUREMENT = {
  FT: 'FT',
  IN: 'IN',
  CM: 'CM',
};

export const TOPS_STYLES = [
  {
    value: 'slim',
    label: {
      value: t(`${TP}.slim`, 'Slim'),
      TK: 'slim',
      TP,
    },
  },
  {
    value: 'cropped',
    label: {
      value: t(`${TP}.cropped`, 'Cropped'),
      TK: 'cropped',
      TP,
    },
  },
  {
    value: 'relaxed',
    label: {
      value: t(`${TP}.relaxed`, 'Relaxed'),
      TK: 'relaxed',
      TP,
    },
  },
  {
    value: 'oversized',
    label: {
      value: t(`${TP}.oversized`, 'Oversized'),
      TK: 'oversized',
      TP,
    },
  },
];

export const DRESSES_STYLES = [
  {
    value: 'mini',
    label: {
      value: t(`${TP}.mini`, 'Mini'),
      TK: 'mini',
      TP,
    },
  },
  {
    value: 'knee-length',
    label: {
      value: t(`${TP}.kneeLength`, 'Knee-length'),
      TK: 'kneeLength',
      TP,
    },
  },
  {
    value: 'midi',
    label: {
      value: t(`${TP}.Midi`, 'Midi'),
      TK: 'Midi',
      TP,
    },
  },
  {
    value: 'long',
    label: {
      value: t(`${TP}.long`, 'Long'),
      TK: 'long',
      TP,
    },
  },
  {
    value: 'tight fit',
    label: {
      value: t(`${TP}.tightFit`, 'Tight Fit'),
      TK: 'tightFit',
      TP,
    },
  },
  {
    value: 'relaxed fit',
    label: {
      value: t(`${TP}.relaxedFit`, 'Relaxed Fit'),
      TK: 'relaxedFit',
      TP,
    },
  },
];

export const PANTS_STYLES = [
  {
    value: 'skinny fit',
    label: {
      value: t(`${TP}.skinnyFit`, 'Skinny Fit'),
      TK: 'skinnyFit',
      TP,
    },
  },
  {
    value: 'tapered fit',
    label: {
      value: t(`${TP}.taperedFit`, 'Tapered Fit'),
      TK: 'taperedFit',
      TP,
    },
  },
  {
    value: 'straight fit',
    label: {
      value: t(`${TP}.straightLeg`, 'Straight Leg'),
      TK: 'straightLeg',
      TP,
    },
  },
  {
    value: 'cropped leg',
    label: {
      value: t(`${TP}.croppedLeg`, 'Cropped Leg'),
      TK: 'croppedLeg',
      TP,
    },
  },
  {
    value: 'relaxed fit',
    label: {
      value: t(`${TP}.relaxedFit`, 'Relaxed Fit'),
      TK: 'relaxedFit',
      TP,
    },
  },
  {
    value: 'baggy fit',
    label: {
      value: t(`${TP}.baggyFit`, 'Baggy Fit'),
      TK: 'baggyFit',
      TP,
    },
  },
  {
    value: 'wide leg',
    label: {
      value: t(`${TP}.wideLeg`, 'Wide Leg'),
      TK: 'wideLeg',
      TP,
    },
  },
];

export const SHORTS_STYLES = [
  {
    value: 'high rise',
    label: {
      value: t(`${TP}.highRise`, 'High Rise'),
      TK: 'highRise',
      TP,
    },
  },
  {
    value: 'mid rise',
    label: {
      value: t(`${TP}.midRise`, 'Mid Rise'),
      TK: 'midRise',
      TP,
    },
  },
  {
    value: 'low rise',
    label: {
      value: t(`${TP}.lowRise`, 'Low Rise'),
      TK: 'lowRise',
      TP,
    },
  },
  {
    value: 'short',
    label: {
      value: t(`${TP}.short`, 'Short'),
      TK: 'short',
      TP,
    },
  },
  {
    value: 'knee-length',
    label: {
      value: t(`${TP}.KneeLength`, 'Knee-length'),
      TK: 'KneeLength',
      TP,
    },
  },
  {
    value: 'long',
    label: {
      value: t(`${TP}.long`, 'Long'),
      TK: 'long',
      TP,
    },
  },
  {
    value: 'tight fit',
    label: {
      value: t(`${TP}.tightFit`, 'Tight Fit'),
      TK: 'tightFit',
      TP,
    },
  },
  {
    value: 'relaxed fit',
    label: {
      value: t(`${TP}.relaxedFit`, 'Relaxed Fit'),
      TK: 'relaxedFit',
      TP,
    },
  },
  {
    value: 'baggy fit',
    label: {
      value: t(`${TP}.BaggyFit`, 'Baggy Fit'),
      TK: 'BaggyFit',
      TP,
    },
  },
];

export const SNEAKERS_FIT = [
  {
    value: {
      value: t(`${TP}.oneSizeSmallValue`, 'one size small'),
      TK: 'oneSizeSmallValue',
      TP,
    },
    label: {
      value: t(`${TP}.oneSizeSmall`, 'One size small'),
      TK: 'oneSizeSmall',
      TP,
    },
  },
  {
    value: {
      value: t(`${TP}.halfSizeSmallValue`, 'half size small'),
      TK: 'halfSizeSmallValue',
      TP,
    },
    label: {
      value: t(`${TP}.halfSizeSmall`, 'Half size small'),
      TK: 'halfSizeSmall',
      TP,
    },
  },
  {
    value: {
      value: t(`${TP}.trueToSizeValue`, 'true to size'),
      TK: 'trueToSizeValue',
      TP,
    },
    label: {
      value: t(`${TP}.trueToSize`, 'True to size'),
      TK: 'trueToSize',
      TP,
    },
  },
  {
    value: {
      value: t(`${TP}.halfSizeLargeValue`, 'half size large'),
      TK: 'halfSizeLargeValue',
      TP,
    },
    label: {
      value: t(`${TP}.halfSizeLarge`, 'Half size large'),
      TK: 'halfSizeLarge',
      TP,
    },
  },
  {
    value: {
      value: t(`${TP}.oneSizeLargeValue`, 'one size large'),
      TK: 'oneSizeLargeValue',
      TP,
    },
    label: {
      value: t(`${TP}.oneSizeLarge`, 'One size large'),
      TK: 'oneSizeLarge',
      TP,
    },
  },
];

export const BODY_SHAPES = {
  UNSET: 1,
  TRIANGLE: 2,
  INVERTED_TRIANGLE: 3,
  RECTANGLE: 4,
  HOURGLASS: 5,
  DIAMOND: 6,
  OVAL: 7,
  OTHER: 8,
};

export const BODY_SHAPE_OPTIONS = {
  OVAL: {
    component: Oval,
    text: {
      value: t(`${TP}.oval`, 'oval'),
      TK: 'oval',
      TP,
    },
    value: BODY_SHAPES.OVAL,
  },
  RECTANGLE: {
    component: Rectangle,
    text: {
      value: t(`${TP}.rectangle`, 'rectangle'),
      TK: 'rectangle',
      TP,
    },
    value: BODY_SHAPES.RECTANGLE,
  },
  DIAMOND: {
    component: Diamond,
    text: {
      value: t(`${TP}.diamond`, 'diamond'),
      TK: 'diamond',
      TP,
    },
    value: BODY_SHAPES.DIAMOND,
  },
  HOURGLASS: {
    component: Hourglass,
    text: {
      value: t(`${TP}.hourglass`, 'hourglass'),
      TK: 'hourglass',
      TP,
    },
    value: BODY_SHAPES.HOURGLASS,
  },
  TRIANGLE: {
    component: Triangle,
    text: {
      value: t(`${TP}.triangle`, 'triangle'),
      TK: 'triangle',
      TP,
    },
    value: BODY_SHAPES.TRIANGLE,
  },
  INVERTED_TRIANGLE: {
    component: Triangle,
    text: {
      value: t(`${TP}.invertedTriangle`, 'inverted triangle'),
      TK: 'invertedTriangle',
      TP,
    },
    value: BODY_SHAPES.INVERTED_TRIANGLE,
  },
  OTHER: {
    component: Slash,
    text: {
      value: t(`${TP}.other`, 'other'),
      TK: 'other',
      TP,
    },
    value: BODY_SHAPES.OTHER,
  },
};
